import { render, staticRenderFns } from "./CopyBetgame.vue?vue&type=template&id=fe284054"
import script from "./CopyBetgame.vue?vue&type=script&lang=js"
export * from "./CopyBetgame.vue?vue&type=script&lang=js"
import style0 from "./CopyBetgame.vue?vue&type=style&index=0&id=fe284054&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports